import { modelJson, weightBundles } from "../model_imports/mobilenet_v2.js";
export var MobileNetV2Model = {
    name: "MobileNetV2",
    numOfWeightBundles: 1,
    modelJson: modelJson,
    weightBundles: weightBundles,
};
//# sourceMappingURL=mobilenet_v2.js.map